import React, { useState, useEffect, useMemo, useRef, useContext, memo, useCallback } from "react";
import { MaterialTableGroups } from "./MaterialTableGroups";
import { Spinner } from "react-bootstrap";
import ConfirmModal from "../../../utilities/confirm-modal";
import {
  setLocalStorageObject,
  getLocalStorageObject,
  calculatePositionRealisedPnl,
  calculatePositionUnrealisedPnl,
  filterPosition
} from "../../../../util/helper";

const DnDTable = ({
  updateBasket,
  setupdateBasket,
  loder,
  position,
  positionRef,
  isDragBasket,
  setisDragBasket,
  sockSource,
  isFirstTime,
  loadPage,
  tabs,
  buySellClick,
  inputValues,
  socketupdated,
  info,
  width,
  height,
  size,
  columns,
  getPNL,
  basketSLTP,
  isClosedPosition,
  totalPNL,
  searchText,
  checkedId,
  setcheckedId,
  groupingMode,
  setGroupingMode,
  subGroupingMode,
  setSubGroupingMode,
  basketMargins
}) => {

  const isBasketAdded = useCallback((value) => {
    //setupdateBasket((updateBasket) => !updateBasket);
    setisDragBasket((isDragBasket) => !isDragBasket);
  }, []);
  const handleChange = useCallback((checked, rowData, type) => {
    if (type === '0') {
      if (checked) {
        if (checkedId.filter((item) => item == rowData.id).length === 0) {
          setcheckedId(prev => [...prev, rowData.id])
        }
      } else {
        setcheckedId(prev => prev.filter((item) => item != rowData.id))
      }
    } else {
      if (!rowData || (Array.isArray(rowData) && rowData.length === 0) || (typeof rowData === 'object' && Object.keys(rowData).length === 0)) {
        if (!checked) setcheckedId([]);
        return;
      }
      const rowIds = Array.isArray(rowData) ? rowData.map((item) => item.id) : [rowData.id];
      if (checked) {
        setcheckedId(prev => {
          const newIds = rowIds.filter(id => !prev.some(existingId => existingId == id));
          return [...prev, ...newIds]; 
        });
      } else {
        setcheckedId(prev => prev.filter((id) => !rowIds.some(rowId => rowId == id)));
      }
    }
  }, [checkedId, setcheckedId]);
 
 
  return (
    <div
      className="order-window-body opt-chn-tbl p-0"
      style={{ maxHeight: height - 178, maxWidth: width, overflow: "auto", display: 'grid' }}
    >
      {
        loder ? (
          <div className="text-center">
            <Spinner
              size="md"
              className="spinner text-center"
              animation="border"
              variant="primary"
            />
          </div>
        ) : (
          positionRef && positionRef && 
            <MaterialTableGroups
              updateBasket={updateBasket}
              buySellClick={buySellClick}
              inputValues={inputValues}
              info={info}
              source={sockSource}
              isBasketAdded={isBasketAdded}
              items={filterPosition(positionRef, isClosedPosition)}
              columns={columns}
              basketSLTP={basketSLTP}
              isClosedPosition={isClosedPosition}
              handleChange={handleChange}
              checkedId={checkedId}
              totalPNL={totalPNL}
              searchText={searchText}
              groupingMode={groupingMode}
              setGroupingMode={setGroupingMode}
              subGroupingMode={subGroupingMode}
              setSubGroupingMode={setSubGroupingMode}
              basketMargins={basketMargins}
            />
          
        )
      }
    </div>
  );
};

export default memo(DnDTable);
